export const recentOpenfiles =[{
    iconClass:"fa fa-file-image-o txt-primary",
    fileName:"Logo.psd",
    fileSize:"2.0 MB",
    lastOpen:"1 hour ago"
},
{
    iconClass:"fa fa-file-archive-o txt-secondary",
    fileName:"Project.zip",
    fileSize:"1.90 GB",
    lastOpen:"1 hour ago"
},
{
    iconClass:"fa fa-file-excel-o txt-success",
    fileName:"Backend.xls",
    fileSize:"2.0 MB",
    lastOpen:"1 hour ago"
},
{
    iconClass:"fa fa-file-text-o txt-info",
    fileName:"requirements.txt",
    fileSize:"0.90 KB",
    lastOpen:"1 hour ago"
}]

export const folders =[{
    iconClass:"fa fa-file-archive-o f-36 txt-warning",
    folderName:"Endless admin",
    folderSize:"204 files, 50mb",
},
{
    iconClass:"fa fa-folder f-36 txt-warning",
    folderName:"Endless admin",
    folderSize:"101 files, 10mb",
},
{
    iconClass:"fa fa-file-archive-o f-36 txt-warning",
    folderName:"Endless admin",
    folderSize:"25 files, 2mb",
},
{
    iconClass:"fa fa-folder f-36 txt-warning",
    folderName:"Endless admin",
    folderSize:"25 files, 2mb"
}]
export const files =[{
    iconClass:"fa fa-file-image-o txt-primary",
    fileName:"Logo.psd",
    fileSize:"2.0 MB",
    lastOpen:"1 hour ago"
},
{
    iconClass:"fa fa-file-text-o txt-info",
    fileName:"requirements.txt",
    fileSize:"0.90 KB",
    lastOpen:"1 hour ago"
},
{
    iconClass:"fa fa-file-excel-o txt-success",
    fileName:"Backend.xls",
    fileSize:"2.0 MB",
    lastOpen:"1 hour ago"
},
{
    iconClass:"fa fa-file-archive-o txt-secondary",
    fileName:"Project.zip",
    fileSize:"1.90 GB",
    lastOpen:"1 hour ago"
},

]